const animations = () => {

    let offset = '-5%';

    jQuery('.anim-ready').viewportChecker({
        classToAdd: 'anim-done',
        classToAddForFullView: false,
        offset
    });

};